var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 104,
    viewBox: "0 0 113 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1569_14038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84889 8.30591C5.03308 8.30797 3.29224 9.02731 2.00827 10.3061C0.724305 11.5849 0.00206531 13.3188 0 15.1273V93.714C0.0020831 95.5225 0.724333 97.2564 2.0083 98.5352C3.29227 99.814 5.0331 100.533 6.84889 100.535H64.7302C66.5459 100.533 68.2868 99.8139 69.5707 98.5351C70.8547 97.2563 71.5769 95.5225 71.579 93.714V15.1273C71.5769 13.3188 70.8547 11.585 69.5707 10.3061C68.2868 9.02733 66.546 8.30798 64.7302 8.30591H6.84889Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0173 13.1508H3.56152V95.69H68.0173V13.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5908 27.9456H11.9873V31.0602H59.5908V27.9456Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5908 36.2515H11.9873V39.3662H59.5908V36.2515Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5908 44.5574H11.9873V47.6721H59.5908V44.5574Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5908 52.8633H11.9873V55.978H59.5908V52.8633Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5908 61.1691H11.9873V64.2838H59.5908V61.1691Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5908 69.4747H11.9873V72.5894H59.5908V69.4747Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5908 77.7806H11.9873V80.8953H59.5908V77.7806Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2609 7.91732L13.0576 16.521L24.164 76.9675L71.3673 68.3638L60.2609 7.91732Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0814 19.8768L21.2197 26.231L21.6388 28.512L56.5006 22.1578L56.0814 19.8768Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1987 25.9594L22.3369 32.3136L22.756 34.5946L57.6178 28.2404L57.1987 25.9594Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3168 32.042L23.4551 38.3962L23.8742 40.6772L58.7359 34.323L58.3168 32.042Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.434 38.1247L24.5723 44.4789L24.9914 46.7599L59.8531 40.4057L59.434 38.1247Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.551 44.2074L25.6895 50.5615L26.1086 52.8425L60.9701 46.4884L60.551 44.2074Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6694 50.2903L26.8076 56.6445L27.2267 58.9255L62.0885 52.5713L61.6694 50.2903Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7876 56.3726L27.9258 62.7268L28.3449 65.0078L63.2067 58.6536L62.7876 56.3726Z",
    fill: "#EF486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6728 74.0409L80.3164 76.4754L83.459 93.5791L96.8154 91.1446L93.6728 74.0409Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4902 77.4251L82.626 79.2231L82.7446 79.8685L92.6088 78.0706L92.4902 77.4251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8057 79.1462L82.9414 80.9441L83.06 81.5895L92.9243 79.7916L92.8057 79.1462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1221 80.8672L83.2578 82.6652L83.3764 83.3106L93.2407 81.5126L93.1221 80.8672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4385 82.5885L83.5742 84.3865L83.6928 85.0319L93.5571 83.2339L93.4385 82.5885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7549 84.3096L83.8906 86.1075L84.0092 86.753L93.8735 84.955L93.7549 84.3096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0713 86.0306L84.207 87.8286L84.3256 88.474L94.1899 86.676L94.0713 86.0306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3877 87.752L84.5234 89.5499L84.642 90.1953L94.5063 88.3974L94.3877 87.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7242 4.32596H42.0443V3.16783C42.0443 2.32767 41.7092 1.52192 41.1127 0.927835C40.5162 0.333752 39.7072 0 38.8637 0H32.7159C31.8723 7.55176e-07 31.0634 0.333753 30.4669 0.927836C29.8704 1.52192 29.5353 2.32767 29.5353 3.16783V4.32596H23.8554C23.4377 4.32596 23.0241 4.4079 22.6382 4.5671C22.2523 4.72629 21.9017 4.95963 21.6064 5.25379C21.311 5.54795 21.0768 5.89717 20.9169 6.28151C20.7571 6.66585 20.6748 7.07778 20.6748 7.49378V16.2656H50.9048V7.49378C50.9048 7.07778 50.8225 6.66585 50.6626 6.28151C50.5028 5.89717 50.2685 5.54795 49.9732 5.25379C49.6778 4.95963 49.3272 4.72629 48.9413 4.5671C48.5554 4.4079 48.1418 4.32596 47.7242 4.32596V4.32596Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7502 89.688C34.6893 89.0479 35.6545 88.3822 36.7697 88.0912C37.7872 87.8258 38.9555 87.896 39.7603 88.638C40.4098 89.2369 40.684 90.1573 40.2028 90.9451C40.0996 91.1248 39.9593 91.2807 39.7912 91.4025C39.6231 91.5243 39.431 91.6093 39.2276 91.6518C39.031 91.6777 38.8311 91.6535 38.6464 91.5817C38.4618 91.5098 38.2983 91.3926 38.1714 91.2409C37.9191 90.9632 37.7682 90.5528 37.9022 90.1867C38.0432 89.8018 38.4203 89.5665 38.7907 89.4351C39.2219 89.2991 39.6659 89.2077 40.1159 89.1624L41.9587 88.9112L49.5017 87.8827L57.9018 86.7374C57.9682 86.7187 58.0245 86.6747 58.0586 86.6149C58.0926 86.5552 58.1017 86.4844 58.0838 86.4181C58.064 86.3527 58.0196 86.2973 57.9599 86.2636C57.9003 86.2298 57.8298 86.2203 57.7633 86.2368L41.0487 88.5158C40.4442 88.5982 39.8311 88.6572 39.2328 88.7783C38.7618 88.8542 38.3152 89.039 37.9289 89.3178C37.1282 89.9491 37.1854 91.0659 37.9222 91.7264C38.6681 92.395 39.7496 92.2799 40.4041 91.5414C40.735 91.1677 40.9315 90.6947 40.9624 90.1973C40.9933 89.6999 40.8569 89.2065 40.5748 88.7949C39.8602 87.7219 38.5582 87.3096 37.3142 87.4618C35.8755 87.6378 34.6557 88.4433 33.4871 89.2398C33.212 89.4273 33.4724 89.8774 33.7502 89.688V89.688Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3994 70.4498L92.5732 72.1802C92.5732 72.1802 91.5308 75.9871 93.7893 75.9871C96.0479 75.9871 94.3105 72.1802 94.3105 72.1802L94.4843 70.7959L92.3994 70.4498Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.18 64.6849L107.383 66.2321C107.383 66.2321 104.433 68.8657 106.329 70.0868C108.226 71.3079 108.842 67.1714 108.842 67.1714L109.742 66.1028L108.18 64.6849Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1797 72.0072L97.612 88.4458L98.8281 100.212C98.8281 100.212 99.8705 102.808 103.345 100.558L102.824 93.81L102.477 87.7536C102.477 87.7536 102.129 81.8703 101.782 80.8321C101.434 79.7939 101.955 76.3331 101.955 76.3331L103.345 70.6229L95.1797 72.0072Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1755 99.8665L97.7856 101.424C97.7856 101.424 95.7008 100.732 95.1796 102.116C94.6584 103.5 99.1755 103.846 99.1755 103.846C99.1755 103.846 103.866 104.192 103.866 103.846C103.866 103.5 103.741 100.853 103.109 100.706C102.476 100.559 99.1755 99.8665 99.1755 99.8665Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.781 71.1419L104.214 88.4457L105.43 100.212C105.43 100.212 106.472 102.808 109.947 100.558L109.426 93.8099L109.078 87.7535C109.078 87.7535 108.731 81.8702 108.383 80.832C108.036 79.7938 108.557 76.333 108.557 76.333L108.209 69.9306L101.781 71.1419Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.777 99.8665L104.387 101.424C104.387 101.424 102.302 100.732 101.781 102.116C101.26 103.5 105.777 103.846 105.777 103.846C105.777 103.846 110.468 104.192 110.468 103.846C110.468 103.5 110.342 100.853 109.71 100.706C109.078 100.559 105.777 99.8665 105.777 99.8665Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5693 43.8019C98.5843 43.8019 100.218 42.175 100.218 40.1681C100.218 38.1612 98.5843 36.5343 96.5693 36.5343C94.5544 36.5343 92.9209 38.1612 92.9209 40.1681C92.9209 42.175 94.5544 43.8019 96.5693 43.8019Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2621 41.812L100.826 44.4076L96.8298 46.138L96.3086 43.0232L99.2621 41.812Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.26 44.1481C101.26 44.1481 97.6114 43.802 96.2215 46.0515L92.7924 48.6472C92.5147 48.8574 92.2978 49.137 92.1637 49.4577C92.0296 49.7783 91.983 50.1286 92.0288 50.473L95.0054 72.8725L99.3488 72.6994L106.472 71.3151L108.557 70.796L107.514 61.625C107.514 61.625 106.298 57.9911 107.688 55.5686L106.993 47.0897L102.129 45.1863L101.26 44.1481Z",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.094 49.3392L92.8334 48.9066C92.8334 48.9066 92.4859 48.9066 92.4859 49.5988C92.4859 50.2909 91.8778 65.2587 91.8778 65.2587L91.7041 70.969L95.0051 71.3151L96.2212 60.5867L95.7 53.4921L93.094 49.3392Z",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.561 46.7434L106.993 47.0895C107.941 48.078 108.758 49.1828 109.425 50.3772C110.468 52.2806 113.595 55.9144 112.9 58.6831C112.205 61.4517 110.12 66.4698 110.12 66.4698L106.819 65.0855C106.819 65.0855 109.425 59.0291 109.251 58.51C109.078 57.9909 106.993 54.8762 106.993 54.8762L104.561 46.7434Z",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0503 38.1782C94.0503 38.1782 91.0968 38.0052 93.0079 36.1018C93.0079 36.1018 94.5715 35.4096 95.2665 35.7557C95.2665 35.7557 96.3089 35.0635 96.3089 35.4096C96.3089 35.4096 99.9573 34.3714 100.479 38.0052C101 41.639 100.131 43.3694 100.131 43.3694L97.6988 43.1963C97.6988 43.1963 98.22 40.2547 96.3089 40.6008C96.3089 40.6008 94.7452 41.1199 94.5715 40.6008C94.3978 40.0817 94.0503 38.1782 94.0503 38.1782Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.4403 71.0553L97.0039 60.6731L95.9615 54.2706L96.3089 61.2345L95.2666 71.0553H95.4403Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1569_14038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 104,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.e839fb6f66a402a053170ccfc5b61fa9.svg";
export { ForwardRef as ReactComponent };